import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "required"]
  static values = {
    requiredCount: Number
  }

  connect() {
    this.requiredCountValue = this.requiredTargets.filter(field => field.required).length
    this.updateSubmitButton()
  }

  validate() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const filledRequiredFields = this.requiredTargets.filter(field => {
      if (!field.required) return false
      return field.value && field.value.trim() !== ''
    }).length

    const allRequiredFilled = filledRequiredFields === this.requiredCountValue
    this.submitTarget.disabled = !allRequiredFilled
  }
}
